import React from 'react';
import { Link } from 'react-router-dom';
import './PageNotFound.css'; // Optional: Import CSS for styling

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="home-link">Go back to Homepage</Link>
    </div>
  );
};

export default PageNotFound;
